import React from 'react';

interface LoadingDisplayProps {
  text?: string;
}

const LoadingDisplay: React.FC<LoadingDisplayProps> = ({ text }) => (
  <div className="flex flex-col items-center justify-center min-h-screen animate-fade-in">
    <span className="text-5xl mb-4 animate-spin-slow" role="img" aria-label="loading">⏳</span>
    <div className="text-xl text-gray-700 font-semibold animate-pulse">
      {text || 'Загрузка...'}
    </div>
  </div>
);

export default LoadingDisplay;
